exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".news-card-content{white-space:pre-wrap}.row.news-row{margin-left:0;margin-right:0}.news-col{overflow:auto}.news-text{word-break:break-word}.news-text a,.news-text a:hover{text-decoration:underline}.news-text img{max-width:100%;max-height:100%}.news-image{max-width:100%;max-height:100%}", ""]);

// exports
